var map = {
	"./points/1.1.jpg": "38c2",
	"./points/1.10.pH.png": "3b84",
	"./points/1.2.TN.png": "5b89",
	"./points/1.3.TP.png": "61ee",
	"./points/1.4.NH3-N.png": "71a3",
	"./points/1.5.COD.png": "30ec",
	"./points/1.6.CODm.png": "a0c9",
	"./points/1.7.Chla.png": "692a",
	"./points/1.8.TSS.png": "a951",
	"./points/1.9.TU.png": "8e5f",
	"./points/10.1.jpg": "4e96",
	"./points/10.10.pH.png": "f23f",
	"./points/10.2.TN.png": "7ece",
	"./points/10.3.TP.png": "f855",
	"./points/10.4.NH3-N.png": "a3d9",
	"./points/10.5.COD.png": "0acb",
	"./points/10.6.CODm.png": "676a",
	"./points/10.7.Chla.png": "fe09",
	"./points/10.8.TSS.png": "6080",
	"./points/10.9.TU.png": "c62a",
	"./points/100.1.jpg": "c045",
	"./points/100.10.png": "2671",
	"./points/100.2.png": "a658",
	"./points/100.3.png": "d382",
	"./points/100.4.png": "7d68",
	"./points/100.5.png": "3a8d",
	"./points/100.6.png": "a483",
	"./points/100.7.png": "e671",
	"./points/100.8.png": "c60a",
	"./points/100.9.png": "8ec1",
	"./points/101.1.jpg": "5d1c",
	"./points/101.10.png": "aa28",
	"./points/101.2.png": "1a2f",
	"./points/101.3.png": "c281",
	"./points/101.4.png": "0d5b",
	"./points/101.5.png": "b9c1",
	"./points/101.6.png": "50f3",
	"./points/101.7.png": "ba5e",
	"./points/101.8.png": "9b48",
	"./points/101.9.png": "a195",
	"./points/102.1.jpg": "8cc8",
	"./points/102.10.png": "0d50",
	"./points/102.2.png": "649e",
	"./points/102.3.png": "9219",
	"./points/102.4.png": "7b72",
	"./points/102.5.png": "824a",
	"./points/102.6.png": "69fb",
	"./points/102.7.png": "24dd",
	"./points/102.8.png": "a6a4",
	"./points/102.9.png": "6880",
	"./points/103.1.jpg": "2340",
	"./points/103.10.png": "4adf",
	"./points/103.2.png": "70ce",
	"./points/103.3.png": "bc62",
	"./points/103.4.png": "ea56",
	"./points/103.5.png": "8a17",
	"./points/103.6.png": "9c2d",
	"./points/103.7.png": "4b3d",
	"./points/103.8.png": "6521",
	"./points/103.9.png": "1619",
	"./points/104.1.jpg": "5f86",
	"./points/104.10.png": "27195",
	"./points/104.2.png": "28d5",
	"./points/104.3.png": "14c7",
	"./points/104.4.png": "cf08",
	"./points/104.5.png": "3e33",
	"./points/104.6.png": "ef4c",
	"./points/104.7.png": "baf2",
	"./points/104.8.png": "fb0c",
	"./points/104.9.png": "44cd",
	"./points/105.1.jpg": "d259",
	"./points/105.10.png": "5927",
	"./points/105.2.png": "214a",
	"./points/105.3.png": "b7b3",
	"./points/105.4.png": "e83d",
	"./points/105.5.png": "83cb",
	"./points/105.6.png": "e2f0",
	"./points/105.7.png": "2b7c",
	"./points/105.8.png": "cc63",
	"./points/105.9.png": "3d53",
	"./points/106.1.jpg": "8c9c",
	"./points/106.10.png": "cf74",
	"./points/106.2.png": "ad2d",
	"./points/106.3.png": "e21d",
	"./points/106.4.png": "e9bc",
	"./points/106.5.png": "a2f3",
	"./points/106.6.png": "2db2",
	"./points/106.7.png": "825d",
	"./points/106.8.png": "8e30",
	"./points/106.9.png": "3bdf",
	"./points/107.1.jpg": "1328",
	"./points/107.10.png": "aac8",
	"./points/107.2.png": "7c48",
	"./points/107.3.png": "a7fa",
	"./points/107.4.png": "07e7",
	"./points/107.5.png": "4b1c",
	"./points/107.6.png": "b855",
	"./points/107.7.png": "d9c1",
	"./points/107.8.png": "e9591",
	"./points/107.9.png": "1e54",
	"./points/108.1.jpg": "e654",
	"./points/108.10.png": "7824",
	"./points/108.2.png": "d3ae",
	"./points/108.3.png": "a161",
	"./points/108.4.png": "c5ed",
	"./points/108.5.png": "3dbc",
	"./points/108.6.png": "7832",
	"./points/108.7.png": "9ecb",
	"./points/108.8.png": "e3c1",
	"./points/108.9.png": "9749",
	"./points/109.1.jpg": "e4bd",
	"./points/109.10.png": "3f76",
	"./points/109.2.png": "a383",
	"./points/109.3.png": "332b",
	"./points/109.4.png": "7b8e",
	"./points/109.5.png": "86ae",
	"./points/109.6.png": "23cc",
	"./points/109.7.png": "1567",
	"./points/109.8.png": "09c2",
	"./points/109.9.png": "916d",
	"./points/11.1.jpg": "5f17",
	"./points/11.10.pH.png": "c77f",
	"./points/11.2.TN.png": "1bc6",
	"./points/11.3.TP.png": "2880",
	"./points/11.4.NH3-N.png": "2099",
	"./points/11.5.COD.png": "6c8c",
	"./points/11.6.CODm.png": "a584",
	"./points/11.7.Chla.png": "6b9f",
	"./points/11.8.TSS.png": "28fa",
	"./points/11.9.TU.png": "f8be",
	"./points/110.1.jpg": "3db6",
	"./points/110.10.png": "65be",
	"./points/110.2.png": "990c",
	"./points/110.3.png": "57c2",
	"./points/110.4.png": "a766",
	"./points/110.5.png": "0fcc",
	"./points/110.6.png": "5fa3",
	"./points/110.7.png": "d9a3",
	"./points/110.8.png": "691e",
	"./points/110.9.png": "1dec",
	"./points/111.1.jpg": "102f",
	"./points/111.10.png": "7f33",
	"./points/111.2.png": "ee43",
	"./points/111.3.png": "e863",
	"./points/111.4.png": "9451",
	"./points/111.5.png": "ccca",
	"./points/111.6.png": "6f74",
	"./points/111.7.png": "80b8",
	"./points/111.8.png": "e5a8",
	"./points/111.9.png": "c31f",
	"./points/112.1.jpg": "c440",
	"./points/112.10.png": "a157",
	"./points/112.2.png": "cbce",
	"./points/112.3.png": "7625",
	"./points/112.4.png": "7a60",
	"./points/112.5.png": "5a71",
	"./points/112.6.png": "f5aa",
	"./points/112.7.png": "47dc",
	"./points/112.8.png": "73ec",
	"./points/112.9.png": "5a7b",
	"./points/113.1.jpg": "f7a7",
	"./points/113.10.png": "bcf0",
	"./points/113.2.png": "b94d",
	"./points/113.3.png": "4d28",
	"./points/113.4.png": "41b5",
	"./points/113.5.png": "a00b",
	"./points/113.6.png": "68ae",
	"./points/113.7.png": "25c9",
	"./points/113.8.png": "894f",
	"./points/113.9.png": "6fea",
	"./points/114.1.jpg": "466c",
	"./points/114.10.png": "c1fa",
	"./points/114.2.png": "0b79",
	"./points/114.3.png": "a8a8",
	"./points/114.4.png": "f52c",
	"./points/114.5.png": "66c7",
	"./points/114.6.png": "e158",
	"./points/114.7.png": "0b5b",
	"./points/114.8.png": "e58a",
	"./points/114.9.png": "e9a3",
	"./points/115.1.jpg": "7aa9",
	"./points/115.10.png": "cc60",
	"./points/115.2.png": "7318",
	"./points/115.3.png": "0447",
	"./points/115.4.png": "100c",
	"./points/115.5.png": "ab69",
	"./points/115.6.png": "a323",
	"./points/115.7.png": "fc1b",
	"./points/115.8.png": "6b2c",
	"./points/115.9.png": "9a0c",
	"./points/116.1.jpg": "1dc0",
	"./points/116.10.png": "e886",
	"./points/116.2.png": "e58f",
	"./points/116.3.png": "fe86",
	"./points/116.4.png": "40a1",
	"./points/116.5.png": "31ed",
	"./points/116.6.png": "6130",
	"./points/116.7.png": "966c",
	"./points/116.8.png": "a4cc",
	"./points/116.9.png": "0260",
	"./points/117.1.jpg": "f54d",
	"./points/117.10.png": "d0a9",
	"./points/117.2.png": "0551",
	"./points/117.3.png": "607d0",
	"./points/117.4.png": "0f20",
	"./points/117.5.png": "2a99",
	"./points/117.6.png": "04f1",
	"./points/117.7.png": "ca08",
	"./points/117.8.png": "17c4",
	"./points/117.9.png": "9063",
	"./points/118.1.jpg": "ef7d",
	"./points/118.10.png": "1ad2",
	"./points/118.2.png": "168a",
	"./points/118.3.png": "539d",
	"./points/118.4.png": "c252",
	"./points/118.5.png": "11d5",
	"./points/118.6.png": "94c2",
	"./points/118.7.png": "80f0a",
	"./points/118.8.png": "db4c",
	"./points/118.9.png": "7bcf",
	"./points/119.1.jpg": "2b64",
	"./points/119.10.png": "33ee",
	"./points/119.2.png": "b717",
	"./points/119.3.png": "509c",
	"./points/119.4.png": "8afd",
	"./points/119.5.png": "abc2",
	"./points/119.6.png": "d08e",
	"./points/119.7.png": "6afa",
	"./points/119.8.png": "b8c2",
	"./points/119.9.png": "d371",
	"./points/12.1.jpg": "9590",
	"./points/12.10.pH.png": "189c",
	"./points/12.2.TN.png": "b65a",
	"./points/12.3.TP.png": "4b8e",
	"./points/12.4.NH3-N.png": "4223",
	"./points/12.5.COD.png": "ad8e",
	"./points/12.6.CODm.png": "b4cc",
	"./points/12.7.Chla.png": "b0e2",
	"./points/12.8.TSS.png": "0f36",
	"./points/12.9.TU.png": "1d0c",
	"./points/120.1.jpg": "0d54",
	"./points/120.10.png": "98a1",
	"./points/120.2.png": "5895",
	"./points/120.3.png": "5114",
	"./points/120.4.png": "3b32",
	"./points/120.5.png": "f1a0",
	"./points/120.6.png": "0fcf",
	"./points/120.7.png": "7e48",
	"./points/120.8.png": "d750",
	"./points/120.9.png": "45fe",
	"./points/121.1.jpg": "37ae",
	"./points/121.10.png": "654b",
	"./points/121.2.png": "4648",
	"./points/121.3.png": "d581",
	"./points/121.4.png": "4703",
	"./points/121.5.png": "00fc",
	"./points/121.6.png": "aa91",
	"./points/121.7.png": "5ce8",
	"./points/121.8.png": "8a94",
	"./points/121.9.png": "e981",
	"./points/122.1.jpg": "ac0d",
	"./points/122.10.png": "5f41",
	"./points/122.2.png": "3b98",
	"./points/122.3.png": "a0c5",
	"./points/122.4.png": "a0a9",
	"./points/122.5.png": "88f4",
	"./points/122.6.png": "d104",
	"./points/122.7.png": "f6a1",
	"./points/122.8.png": "c86d",
	"./points/122.9.png": "7aec",
	"./points/123.1.jpg": "6b74",
	"./points/123.10.png": "49306",
	"./points/123.2.png": "c715",
	"./points/123.3.png": "bda8",
	"./points/123.4.png": "8401",
	"./points/123.5.png": "a1b8",
	"./points/123.6.png": "2363",
	"./points/123.7.png": "587b",
	"./points/123.8.png": "1a24",
	"./points/123.9.png": "5aef",
	"./points/124.1.jpg": "74b6",
	"./points/124.10.png": "c723",
	"./points/124.2.png": "56ce",
	"./points/124.3.png": "0c90",
	"./points/124.4.png": "9251",
	"./points/124.5.png": "798e",
	"./points/124.6.png": "3ce0",
	"./points/124.7.png": "c8b3",
	"./points/124.8.png": "1810",
	"./points/124.9.png": "60f6",
	"./points/125.1.jpg": "f1ce",
	"./points/125.10.png": "d176",
	"./points/125.2.png": "b303",
	"./points/125.3.png": "dfd1",
	"./points/125.4.png": "5284",
	"./points/125.5.png": "9294",
	"./points/125.6.png": "7714",
	"./points/125.7.png": "6363",
	"./points/125.8.png": "7409",
	"./points/125.9.png": "2344",
	"./points/126.1.jpg": "7307",
	"./points/126.10.png": "7b6c",
	"./points/126.2.png": "eeb8",
	"./points/126.3.png": "96c0",
	"./points/126.4.png": "1988",
	"./points/126.5.png": "8c35",
	"./points/126.6.png": "e34b",
	"./points/126.7.png": "7e3a",
	"./points/126.8.png": "114b",
	"./points/126.9.png": "4297",
	"./points/127.1.jpg": "ec61",
	"./points/127.10.png": "0e1c",
	"./points/127.2.png": "4d9f",
	"./points/127.3.png": "6adf",
	"./points/127.4.png": "e2fe",
	"./points/127.5.png": "d901",
	"./points/127.6.png": "71ac",
	"./points/127.7.png": "9d72",
	"./points/127.8.png": "cef1",
	"./points/127.9.png": "3513",
	"./points/128.1.jpg": "fa3c",
	"./points/128.10.png": "d456",
	"./points/128.2.png": "6e0f",
	"./points/128.3.png": "3f2e",
	"./points/128.4.png": "fac0",
	"./points/128.5.png": "bc4f",
	"./points/128.6.png": "1899",
	"./points/128.7.png": "f177",
	"./points/128.8.png": "cede",
	"./points/128.9.png": "54a4",
	"./points/129.1.jpg": "e207",
	"./points/129.10.png": "0d5c",
	"./points/129.2.png": "6d37",
	"./points/129.3.png": "c7b6",
	"./points/129.4.png": "9282",
	"./points/129.5.png": "38427",
	"./points/129.6.png": "4579",
	"./points/129.7.png": "ec6e",
	"./points/129.8.png": "0b00",
	"./points/129.9.png": "2420",
	"./points/13.1.jpg": "b265",
	"./points/13.10.pH.png": "aa71",
	"./points/13.2.TN.png": "6baa",
	"./points/13.3.TP.png": "9fba",
	"./points/13.4.NH3-N.png": "e173",
	"./points/13.5.COD.png": "9609",
	"./points/13.6.CODm.png": "ae7d",
	"./points/13.7.Chla.png": "6915",
	"./points/13.8.TSS.png": "4c43",
	"./points/13.9.TU.png": "dc14",
	"./points/130.1.jpg": "c18a",
	"./points/130.10.png": "de92",
	"./points/130.2.png": "0df9",
	"./points/130.3.png": "5b90",
	"./points/130.4.png": "b14d",
	"./points/130.5.png": "7daa",
	"./points/130.6.png": "e56c",
	"./points/130.7.png": "2eca",
	"./points/130.8.png": "4798",
	"./points/130.9.png": "547d",
	"./points/131.1.jpg": "dfa6",
	"./points/131.10.png": "1158",
	"./points/131.2.png": "f33c",
	"./points/131.3.png": "2052",
	"./points/131.4.png": "17c7",
	"./points/131.5.png": "86ba",
	"./points/131.6.png": "0789",
	"./points/131.7.png": "1ca7",
	"./points/131.8.png": "40ab",
	"./points/131.9.png": "42fd",
	"./points/132.1.jpg": "e241",
	"./points/132.10.png": "9668",
	"./points/132.2.png": "eeec",
	"./points/132.3.png": "a72f",
	"./points/132.4.png": "5afc",
	"./points/132.5.png": "9b1a",
	"./points/132.6.png": "7c85",
	"./points/132.7.png": "7fcf",
	"./points/132.8.png": "c958",
	"./points/132.9.png": "45a4",
	"./points/133.1.jpg": "b088",
	"./points/133.10.png": "bd37",
	"./points/133.2.png": "2379",
	"./points/133.3.png": "4de6",
	"./points/133.4.png": "d60c",
	"./points/133.5.png": "41a3",
	"./points/133.6.png": "6d9a",
	"./points/133.7.png": "a795",
	"./points/133.8.png": "1f9e",
	"./points/133.9.png": "1b0d",
	"./points/134.1.jpg": "9deb",
	"./points/134.10.png": "d032",
	"./points/134.2.png": "82d9",
	"./points/134.3.png": "bdc9",
	"./points/134.4.png": "318a",
	"./points/134.5.png": "2581",
	"./points/134.6.png": "1a4f",
	"./points/134.7.png": "e3e5",
	"./points/134.8.png": "6f44",
	"./points/134.9.png": "21a5",
	"./points/135.1.jpg": "b162",
	"./points/135.10.png": "c9d5",
	"./points/135.2.png": "dda9",
	"./points/135.3.png": "17c26",
	"./points/135.4.png": "2f629",
	"./points/135.5.png": "e862",
	"./points/135.6.png": "0a9d",
	"./points/135.7.png": "1d94",
	"./points/135.8.png": "bd35",
	"./points/135.9.png": "607a",
	"./points/136.1.jpg": "52fa",
	"./points/136.10.png": "4152",
	"./points/136.2.png": "7295",
	"./points/136.3.png": "a5ef",
	"./points/136.4.png": "6a0f",
	"./points/136.5.png": "7842",
	"./points/136.6.png": "8a87",
	"./points/136.7.png": "68f4",
	"./points/136.8.png": "298a",
	"./points/136.9.png": "4378",
	"./points/137.1.jpg": "ddcc",
	"./points/137.10.png": "3f71",
	"./points/137.2.png": "d085",
	"./points/137.3.png": "5bdf",
	"./points/137.4.png": "2f9b",
	"./points/137.5.png": "730c",
	"./points/137.6.png": "8bba",
	"./points/137.7.png": "2e6e",
	"./points/137.8.png": "624c",
	"./points/137.9.png": "f57c",
	"./points/138.1.jpg": "1e29",
	"./points/138.10.png": "44dd",
	"./points/138.2.png": "5f63",
	"./points/138.3.png": "ca41",
	"./points/138.4.png": "0597",
	"./points/138.5.png": "8d98",
	"./points/138.6.png": "f7dc7",
	"./points/138.7.png": "c5f8",
	"./points/138.8.png": "c040",
	"./points/138.9.png": "bd93",
	"./points/139.1.jpg": "361c",
	"./points/139.10.png": "0e09",
	"./points/139.2.png": "7c3b",
	"./points/139.3.png": "35e6",
	"./points/139.4.png": "4140",
	"./points/139.5.png": "815e",
	"./points/139.6.png": "d6c3",
	"./points/139.7.png": "c7ec",
	"./points/139.8.png": "42f1",
	"./points/139.9.png": "5b00",
	"./points/14.1.jpg": "42f13",
	"./points/14.10.pH.png": "e378",
	"./points/14.2.TN.png": "44eb",
	"./points/14.3.TP.png": "0fad",
	"./points/14.4.NH3-N.png": "b80f",
	"./points/14.5.COD.png": "75d5",
	"./points/14.6.CODm.png": "539f",
	"./points/14.7.Chla.png": "c915",
	"./points/14.8.TSS.png": "1c9d",
	"./points/14.9.TU.png": "2d57",
	"./points/140.1.jpg": "595a",
	"./points/140.10.png": "1a45",
	"./points/140.2.png": "0ceb",
	"./points/140.3.png": "6294",
	"./points/140.4.png": "9097",
	"./points/140.5.png": "962e",
	"./points/140.6.png": "d013",
	"./points/140.7.png": "3757",
	"./points/140.8.png": "22aa",
	"./points/140.9.png": "1cb5",
	"./points/141.1.jpg": "2e2f",
	"./points/141.10.png": "7ce4",
	"./points/141.2.png": "9d45",
	"./points/141.3.png": "25ae",
	"./points/141.4.png": "7cf2",
	"./points/141.5.png": "2563",
	"./points/141.6.png": "479a",
	"./points/141.7.png": "8b0e",
	"./points/141.8.png": "c29c",
	"./points/141.9.png": "e5d9",
	"./points/142.1.jpg": "c498",
	"./points/142.10.png": "92aa",
	"./points/142.2.png": "d713",
	"./points/142.3.png": "6d87",
	"./points/142.4.png": "d763",
	"./points/142.5.png": "4a5f",
	"./points/142.6.png": "67f2",
	"./points/142.7.png": "ef2a",
	"./points/142.8.png": "a732",
	"./points/142.9.png": "40c1",
	"./points/143.1.jpg": "2061",
	"./points/143.10.png": "930a",
	"./points/143.2.png": "74f7",
	"./points/143.3.png": "de11",
	"./points/143.4.png": "5466",
	"./points/143.5.png": "6f27",
	"./points/143.6.png": "734d",
	"./points/143.7.png": "7f68",
	"./points/143.8.png": "22a9",
	"./points/143.9.png": "8118",
	"./points/144.1.jpg": "3867",
	"./points/144.10.png": "72f2",
	"./points/144.2.png": "70d6",
	"./points/144.3.png": "695d",
	"./points/144.4.png": "2510",
	"./points/144.5.png": "2659",
	"./points/144.6.png": "9864",
	"./points/144.7.png": "3905",
	"./points/144.8.png": "5d98",
	"./points/144.9.png": "c02d",
	"./points/145.1.jpg": "69a1",
	"./points/145.10.png": "7ff3",
	"./points/145.2.png": "225f",
	"./points/145.3.png": "504f",
	"./points/145.4.png": "ea54",
	"./points/145.5.png": "ad8c",
	"./points/145.6.png": "3b1c",
	"./points/145.7.png": "b028",
	"./points/145.8.png": "d3fa",
	"./points/145.9.png": "a9fb",
	"./points/146.1.jpg": "01da",
	"./points/146.10.png": "6dd1",
	"./points/146.2.png": "fd4d",
	"./points/146.3.png": "cb6f",
	"./points/146.4.png": "2f54",
	"./points/146.5.png": "efe7",
	"./points/146.6.png": "e5bf",
	"./points/146.7.png": "7f1b",
	"./points/146.8.png": "64f2",
	"./points/146.9.png": "fbc5",
	"./points/15.1.jpg": "3303",
	"./points/15.10.pH.png": "a059",
	"./points/15.2.TN.png": "ee2e",
	"./points/15.3.TP.png": "8707",
	"./points/15.4.NH3-N.png": "6ccb",
	"./points/15.5.COD.png": "b437",
	"./points/15.6.CODm.png": "97423",
	"./points/15.7.Chla.png": "c4a4",
	"./points/15.8.TSS.png": "170e",
	"./points/15.9.TU.png": "cd88",
	"./points/16.1.jpg": "955b",
	"./points/16.10.pH.png": "5ea3",
	"./points/16.2.TN.png": "b41b",
	"./points/16.3.TP.png": "66f9",
	"./points/16.4.NH3-N.png": "adfa",
	"./points/16.5.COD.png": "dc4a",
	"./points/16.6.CODm.png": "1c86",
	"./points/16.7.Chla.png": "c2dd",
	"./points/16.8.TSS.png": "7b5b",
	"./points/16.9.TU.png": "1719",
	"./points/17.1.jpg": "7d80",
	"./points/17.10.pH.png": "2894",
	"./points/17.2.TN.png": "cea8",
	"./points/17.3.TP.png": "2fa7",
	"./points/17.4.NH3-N.png": "9178",
	"./points/17.5COD.png": "8dcb",
	"./points/17.6.CODm.png": "bd50",
	"./points/17.7.Chla.png": "321d",
	"./points/17.8.TSS.png": "6937",
	"./points/17.9.TU.png": "7a16",
	"./points/18.1.jpg": "d74e",
	"./points/18.10.pH.png": "62aa",
	"./points/18.2.TN.png": "bc77",
	"./points/18.3.TP.png": "cb4a",
	"./points/18.4.NH3-N.png": "59e0",
	"./points/18.5.COD.png": "f7ac",
	"./points/18.6.CODm.png": "a18d",
	"./points/18.7.Chla.png": "44c1",
	"./points/18.8.TSS.png": "f280",
	"./points/18.9.TU.png": "bd03",
	"./points/19.1.jpg": "7856",
	"./points/19.10.pH.png": "e915",
	"./points/19.2.TN.png": "95a5",
	"./points/19.3.TP.png": "755c",
	"./points/19.4.NH3-N.png": "bdb7",
	"./points/19.5.COD.png": "8c63",
	"./points/19.6.CODm.png": "9351",
	"./points/19.7.Chla.png": "c7c0",
	"./points/19.8.TSS.png": "f988",
	"./points/19.9.TU.png": "1ba0",
	"./points/2.1.jpg": "13c2",
	"./points/2.10.pH.png": "d0a8",
	"./points/2.2.TN.png": "0a19",
	"./points/2.3.TP.png": "c28a",
	"./points/2.4.NH3-N.png": "082a",
	"./points/2.5.COD.png": "5e98",
	"./points/2.6.CODm.png": "daf1",
	"./points/2.7.Chla.png": "181b",
	"./points/2.8.TSS.png": "5502",
	"./points/2.9.TU.png": "de10",
	"./points/20.1.jpg": "6eed",
	"./points/20.10.pH.png": "bbef",
	"./points/20.2.TN.png": "0468",
	"./points/20.3.TP.png": "7213",
	"./points/20.4.NH3-N.png": "110a",
	"./points/20.5.COD.png": "f733",
	"./points/20.6.CODm.png": "82ad",
	"./points/20.7.Chla.png": "ad15",
	"./points/20.8.TSS.png": "697f",
	"./points/20.9.TU.png": "ddd5",
	"./points/21.1.jpg": "0f14",
	"./points/21.10.pH.png": "75e2",
	"./points/21.2.TN.png": "8955",
	"./points/21.3.TP.png": "4476",
	"./points/21.4.NH3-N.png": "c3d5",
	"./points/21.5.COD.png": "7a27",
	"./points/21.6.CODm .png": "18a0",
	"./points/21.7.Chla.png": "cc5c",
	"./points/21.8.TSS.png": "a254",
	"./points/21.9.TU.png": "da9c",
	"./points/22.1.jpg": "046b",
	"./points/22.10.pH.png": "ddfb",
	"./points/22.2.TN.png": "ac33",
	"./points/22.3.TP.png": "5495",
	"./points/22.4.NH3-N.png": "7819",
	"./points/22.5.COD.png": "65af",
	"./points/22.6.CODm.png": "eca3",
	"./points/22.7.Chla.png": "fd0e",
	"./points/22.8.TSS.png": "8385",
	"./points/22.9.TU.png": "9dba",
	"./points/23.1.jpg": "0130",
	"./points/23.10.pH.png": "7a30",
	"./points/23.2.TN.png": "348e",
	"./points/23.3.TP.png": "b2b3",
	"./points/23.4.NH3-N.png": "0b9b",
	"./points/23.5.COD.png": "079b",
	"./points/23.6.CODm.png": "221e",
	"./points/23.7.Chla.png": "1a62",
	"./points/23.8.TSS.png": "1cf2",
	"./points/23.9.TU.png": "e364",
	"./points/24.1.jpg": "5f9e",
	"./points/24.10.pH.png": "c2a3",
	"./points/24.2.TN.png": "652a",
	"./points/24.3.TP.png": "6703",
	"./points/24.4.NH3-N.png": "86e7",
	"./points/24.5.COD.png": "abcc",
	"./points/24.6.CODm.png": "97ae",
	"./points/24.7.Chla.png": "df11",
	"./points/24.8.TSS.png": "35d5",
	"./points/24.9.TU.png": "5b32",
	"./points/25.1.jpg": "dd55",
	"./points/25.10.pH.png": "42ce",
	"./points/25.2.TN.png": "1e21",
	"./points/25.3.TP.png": "12fd",
	"./points/25.4.NH3-N.png": "307a",
	"./points/25.5.COD.png": "78d1",
	"./points/25.6.CODm.png": "157e",
	"./points/25.7.Chla.png": "0b9e",
	"./points/25.8.TSS.png": "d843",
	"./points/25.9.TU.png": "934e",
	"./points/26.1.jpg": "0c27",
	"./points/26.10.pH.png": "563f",
	"./points/26.2.TN.png": "ee1b",
	"./points/26.3.TP.png": "9545",
	"./points/26.4.NH3-N.png": "ebb1",
	"./points/26.5.COD.png": "ed2d",
	"./points/26.6.CODm.png": "f7dd",
	"./points/26.7.Chla.png": "0be8",
	"./points/26.8.TSS.png": "4ded",
	"./points/26.9.TU.png": "0926",
	"./points/27.1.jpg": "c5cc",
	"./points/27.10.pH.png": "35d4",
	"./points/27.2.TN.png": "1cb9",
	"./points/27.3.TP.png": "af6c",
	"./points/27.4.NH3-N.png": "442e",
	"./points/27.5.COD.png": "9d49",
	"./points/27.6.CODm.png": "419a",
	"./points/27.7.Chla.png": "b417",
	"./points/27.8.TSS.png": "98ab",
	"./points/27.9.TU.png": "6770",
	"./points/28.1.jpg": "9b0f",
	"./points/28.10.pH.png": "2ca4",
	"./points/28.2.TN.png": "afc3",
	"./points/28.3.TP.png": "76d6",
	"./points/28.4.NH3-N.png": "4c07",
	"./points/28.5.COD.png": "29f0",
	"./points/28.6.CODm.png": "f3425",
	"./points/28.7.Chla.png": "4b0a",
	"./points/28.8.TSS.png": "9797",
	"./points/28.9.TU.png": "2d88",
	"./points/29.1.jpg": "79ab",
	"./points/29.10.pH.png": "9773",
	"./points/29.2.TN.png": "ac97",
	"./points/29.3.TP.png": "1e5c",
	"./points/29.4.NH3-N.png": "0b4f",
	"./points/29.5.COD.png": "40d1",
	"./points/29.6.CODm.png": "919e",
	"./points/29.7.Chla.png": "6ebb",
	"./points/29.8.TSS.png": "c85b",
	"./points/29.9.TU.png": "900f",
	"./points/3.1.jpg": "9f85",
	"./points/3.10.pH.png": "03f7",
	"./points/3.2.TN.png": "2d2c",
	"./points/3.3.TP.png": "4606",
	"./points/3.4.NH3-N.png": "01a8",
	"./points/3.5.COD.png": "bf58",
	"./points/3.6.CODm.png": "533e",
	"./points/3.7.Chla.png": "f0b6",
	"./points/3.8.TSS.png": "cb0c",
	"./points/3.9.TU.png": "6441",
	"./points/30.1.jpg": "f20f",
	"./points/30.10.pH.png": "1d48",
	"./points/30.2.TN.png": "5fa30",
	"./points/30.3.TP.png": "047e",
	"./points/30.4.NH3-N.png": "6b20",
	"./points/30.5.COD.png": "c145",
	"./points/30.6.CODm.png": "e038",
	"./points/30.7.Chla.png": "2195",
	"./points/30.8.TSS.png": "8772",
	"./points/30.9.TU.png": "bb4c",
	"./points/31.1.jpg": "63f7",
	"./points/31.10.pH.png": "bfaf",
	"./points/31.2.TN.png": "ec64",
	"./points/31.3.TP.png": "623c",
	"./points/31.4.NH3-N.png": "497f",
	"./points/31.5.COD.png": "01d1",
	"./points/31.6.CODm.png": "b1bd",
	"./points/31.7.Chla.png": "e6e6",
	"./points/31.8.TSS.png": "7703",
	"./points/31.9.TU.png": "7309",
	"./points/32.1.jpg": "ca418",
	"./points/32.10.pH.png": "0f3d",
	"./points/32.2.TN.png": "f261",
	"./points/32.3.TP.png": "8717",
	"./points/32.4.NH3-N.png": "b50e",
	"./points/32.5.COD.png": "898d",
	"./points/32.6.CODm.png": "d6ba",
	"./points/32.7.Chla.png": "4cfc",
	"./points/32.8.TSS.png": "0aef",
	"./points/32.9.TU.png": "39ac",
	"./points/33.1.jpg": "ba35",
	"./points/33.10.pH.png": "9f21",
	"./points/33.2.TN.png": "c153",
	"./points/33.3.TP.png": "2faf",
	"./points/33.4.NH3-N.png": "a53b",
	"./points/33.5.COD.png": "ba34",
	"./points/33.6.CODm.png": "0e0e",
	"./points/33.7.Chla.png": "b3e0",
	"./points/33.8.TSS.png": "201c",
	"./points/33.9.TU.png": "5917",
	"./points/34.1.jpg": "ae9c",
	"./points/34.10.pH.png": "f9c2",
	"./points/34.2.TN.png": "9809",
	"./points/34.3.TP.png": "883c",
	"./points/34.4.NH3-N.png": "b745",
	"./points/34.5.COD.png": "d29b",
	"./points/34.6.CODm.png": "6ff2",
	"./points/34.7.Chla.png": "4743",
	"./points/34.8.TSS.png": "e636",
	"./points/34.9.TU.png": "1467",
	"./points/35.1.jpg": "e6bb",
	"./points/35.10.pH.png": "49ef",
	"./points/35.2.TN.png": "8943",
	"./points/35.3.TP.png": "c90e",
	"./points/35.4.NH3-N.png": "c4f4",
	"./points/35.5.COD.png": "6791",
	"./points/35.6.CODm.png": "274f",
	"./points/35.7.Chla.png": "f894",
	"./points/35.8.TSS.png": "aca1",
	"./points/35.9.TU.png": "a82e",
	"./points/36.1.jpg": "3ec2",
	"./points/36.10.pH.png": "a68e",
	"./points/36.2.TN.png": "be20",
	"./points/36.3.TP.png": "2c9c",
	"./points/36.4.NH3-N.png": "8e66",
	"./points/36.5.COD.png": "2971",
	"./points/36.6.CODm.png": "c521",
	"./points/36.7.Chla.png": "b48a",
	"./points/36.8.TSS.png": "e1fb",
	"./points/36.9.TU.png": "446d",
	"./points/37.1.jpg": "3293",
	"./points/37.10.pH.png": "c0af",
	"./points/37.2.TN.png": "8081",
	"./points/37.3.TP.png": "36f0",
	"./points/37.4.NH3-N.png": "370c",
	"./points/37.5.COD.png": "f534",
	"./points/37.6.CODm.png": "1979",
	"./points/37.7.Chla.png": "ef976",
	"./points/37.8.TSS.png": "c3cb",
	"./points/37.9.TU.png": "7326",
	"./points/38.1.jpg": "728f",
	"./points/38.10.pH.png": "1b54",
	"./points/38.2.TN.png": "f843",
	"./points/38.3.TP.png": "a8f7",
	"./points/38.4.NH3-N.png": "0308",
	"./points/38.5.COD.png": "4366",
	"./points/38.6.CODm.png": "e07b",
	"./points/38.7.Chla.png": "83a6",
	"./points/38.8.TSS.png": "7955",
	"./points/38.9.TU.png": "dbd0",
	"./points/39.1.jpg": "df23",
	"./points/39.10.pH.png": "39ce",
	"./points/39.2.TN.png": "3e4e",
	"./points/39.3.TP.png": "5dd8",
	"./points/39.4.NH3-N.png": "5a3c",
	"./points/39.5.COD.png": "609d",
	"./points/39.6.CODm.png": "8947",
	"./points/39.7.Chla.png": "b111",
	"./points/39.8.TSS.png": "aaf1",
	"./points/39.9.TU.png": "3b9b",
	"./points/4.1.jpg": "3163",
	"./points/4.10.pH.png": "1bda",
	"./points/4.2.TN.png": "c9a8",
	"./points/4.3.TP.png": "aa65",
	"./points/4.4.NH3-N.png": "6804",
	"./points/4.5.COD.png": "fe63",
	"./points/4.6.CODm.png": "4c6d",
	"./points/4.7.Chla.png": "b6d3",
	"./points/4.8.TSS.png": "7d83",
	"./points/4.9.TU.png": "d653",
	"./points/40.1.jpg": "1817",
	"./points/40.10.pH.png": "faf57",
	"./points/40.2.TN.png": "68e5",
	"./points/40.3.TP.png": "8981",
	"./points/40.4.NH3-N.png": "53f0",
	"./points/40.5.COD.png": "1bec",
	"./points/40.6.CODm.png": "0a47",
	"./points/40.7.Chla.png": "9931",
	"./points/40.8.TSS.png": "d779",
	"./points/40.9.TU.png": "e44b",
	"./points/41.1.jpg": "fa39",
	"./points/41.10.pH.png": "ff56",
	"./points/41.2.TN.png": "0711",
	"./points/41.3.TP.png": "7aaf",
	"./points/41.4.NH3-N.png": "1509",
	"./points/41.5.COD.png": "7bd7",
	"./points/41.6.CODm.png": "8c44",
	"./points/41.7.Chla.png": "5529",
	"./points/41.8.TSS.png": "b94e",
	"./points/41.9.TU.png": "0051",
	"./points/42.1.jpg": "287e",
	"./points/42.10.pH.png": "9cd8",
	"./points/42.2.TN.png": "3c6c",
	"./points/42.3.TP.png": "8b60",
	"./points/42.4.NH3-N.png": "e231",
	"./points/42.5.COD.png": "1e63",
	"./points/42.6.CODm.png": "5eb8",
	"./points/42.7.Chla.png": "06ea",
	"./points/42.8.TSS.png": "2da5",
	"./points/42.9.TU.png": "322a",
	"./points/43.1.jpg": "b525",
	"./points/43.10.pH.png": "acc5",
	"./points/43.2.TN.png": "0012",
	"./points/43.3.TP.png": "a06f",
	"./points/43.4.NH3-N.png": "1e1b",
	"./points/43.5.COD.png": "39b2",
	"./points/43.6.CODm.png": "dfb4",
	"./points/43.7.Chla.png": "8563",
	"./points/43.8.TSS.png": "35a0",
	"./points/43.9.TU.png": "5c87",
	"./points/44.1.jpg": "1dc5",
	"./points/44.10.pH.png": "fbd0",
	"./points/44.2.TN.png": "5c41",
	"./points/44.3.TP.png": "14b9",
	"./points/44.4.NH3-N.png": "a5bb",
	"./points/44.5.COD.png": "fa96",
	"./points/44.6.CODm.png": "7392",
	"./points/44.7.Chla.png": "13b4",
	"./points/44.8.TSS.png": "404e",
	"./points/44.9.TU.png": "63f2",
	"./points/45.1.jpg": "3701",
	"./points/45.10.pH.png": "c8b3d",
	"./points/45.2.TN.png": "9ef6",
	"./points/45.3.TP.png": "2b4d",
	"./points/45.4.NH3-N.png": "568f",
	"./points/45.5.COD.png": "1cc8",
	"./points/45.6.CODm.png": "4773",
	"./points/45.7.Chla.png": "94c5",
	"./points/45.8.TSS.png": "aa65d",
	"./points/45.9.TU.png": "f10f",
	"./points/46.1.jpg": "d828",
	"./points/46.10.pH.png": "f576",
	"./points/46.2.TN.png": "41b0",
	"./points/46.3.TP.png": "0de1",
	"./points/46.4.NH3-N.png": "4641",
	"./points/46.5.COD.png": "18ee",
	"./points/46.6.CODm.png": "5ac9",
	"./points/46.7.Chla.png": "747a",
	"./points/46.8.TSS.png": "3a73",
	"./points/46.9.TU.png": "89d7",
	"./points/47.1.jpg": "d8b2",
	"./points/47.10.pH.png": "ea94",
	"./points/47.2.TN.png": "36e1",
	"./points/47.3.TP.png": "4162",
	"./points/47.4.NH3-N.png": "3ec0",
	"./points/47.5.COD.png": "1cb3",
	"./points/47.6.CODm.png": "873d",
	"./points/47.7.Chla.png": "9d74",
	"./points/47.8.TSS.png": "b521",
	"./points/47.9.TU.png": "c556",
	"./points/48.1.jpg": "f810",
	"./points/48.10.pH.png": "4c8f",
	"./points/48.11.png": "c71d",
	"./points/48.2.TN.png": "764f",
	"./points/48.3.TP.png": "7b99",
	"./points/48.4.NH3-N.png": "0ad0",
	"./points/48.5.COD.png": "cc14",
	"./points/48.6.CODm.png": "4b71",
	"./points/48.7.Chla.png": "8aca",
	"./points/48.8.TSS.png": "0aa0",
	"./points/48.9.TU.png": "f840",
	"./points/49.1.jpg": "b8c5",
	"./points/49.10.pH.png": "81d1",
	"./points/49.2.TN.png": "a376",
	"./points/49.3.TP.png": "dbcc",
	"./points/49.4.NH3-N.png": "d487",
	"./points/49.5.COD.png": "4c03",
	"./points/49.6.CODm.png": "fa02",
	"./points/49.7.Chla.png": "98b1",
	"./points/49.8.TSS.png": "e2b4",
	"./points/49.9.TU.png": "ed32",
	"./points/5.1.jpg": "c634",
	"./points/5.10.pH.png": "4614",
	"./points/5.2.TN.png": "610a",
	"./points/5.3.TP.png": "51f3",
	"./points/5.4.NH3-N.png": "acbe",
	"./points/5.5.COD.png": "4a6a",
	"./points/5.6.CODm.png": "7c67",
	"./points/5.7.Chla.png": "e1f6",
	"./points/5.8.TSS.png": "ab93",
	"./points/5.9.TU.png": "6fbe",
	"./points/50.1.jpg": "c4a35",
	"./points/50.10.pH.png": "7aea",
	"./points/50.2.TN.png": "f86c",
	"./points/50.3.TP.png": "706b",
	"./points/50.4.NH3-N.png": "1784",
	"./points/50.5.COD.png": "c1d7",
	"./points/50.6.CODm.png": "6376",
	"./points/50.7.Chla.png": "7488",
	"./points/50.8.TSS.png": "6192",
	"./points/50.9.TU.png": "b1e3",
	"./points/51.1.jpg": "5355",
	"./points/51.10.pH.png": "db05",
	"./points/51.2.TN.png": "7412",
	"./points/51.3.TP.png": "77b6",
	"./points/51.4.NH3-N.png": "8b1a0",
	"./points/51.5.COD.png": "615d",
	"./points/51.6.CODm.png": "996c",
	"./points/51.7.Chla.png": "215a",
	"./points/51.8.TSS.png": "e21c",
	"./points/51.9.TU.png": "ae90",
	"./points/52.1.jpg": "7a38",
	"./points/52.10.pH.png": "00cf",
	"./points/52.2.TN.png": "26b8",
	"./points/52.3.TP.png": "7ad5",
	"./points/52.4.NH3-N.png": "f6bb",
	"./points/52.5.COD.png": "c625",
	"./points/52.6.CODm.png": "e568",
	"./points/52.7.Chla.png": "b73f",
	"./points/52.8.TSS.png": "827a",
	"./points/52.9.TU.png": "c83a",
	"./points/53.1.jpg": "4331",
	"./points/53.10.pH.png": "59c4",
	"./points/53.2.TN.png": "1d61",
	"./points/53.3.TP.png": "2b84",
	"./points/53.4.NH3-N.png": "f86d",
	"./points/53.5.COD.png": "27d5",
	"./points/53.6.CODm.png": "c2f1",
	"./points/53.7.Chla.png": "04a8",
	"./points/53.8.TSS.png": "360e",
	"./points/53.9.TU.png": "dde6",
	"./points/54.1.jpg": "557c",
	"./points/54.10.pH.png": "c7eb",
	"./points/54.2.TN.png": "da85",
	"./points/54.3.TP.png": "60a9",
	"./points/54.4.NH3-N.png": "89be",
	"./points/54.5.COD.png": "3dc8",
	"./points/54.6.CODm.png": "ecba",
	"./points/54.7.Chla.png": "e722",
	"./points/54.8.TSS.png": "93f3",
	"./points/54.9.TU.png": "0b97",
	"./points/55.1.jpg": "b2ea",
	"./points/55.10.pH.png": "9d8c",
	"./points/55.2.TN.png": "eb07",
	"./points/55.3.TP.png": "c8e9",
	"./points/55.4.NH3-N.png": "1d84",
	"./points/55.5.COD.png": "4edc",
	"./points/55.6.CODm.png": "6c67",
	"./points/55.7.Chla.png": "e570",
	"./points/55.8.TSS.png": "4db9",
	"./points/55.9.TU.png": "17f7",
	"./points/56.1.jpg": "7efd",
	"./points/56.10.pH.png": "e65f",
	"./points/56.2.TN.png": "c37c",
	"./points/56.3.TP.png": "66b8",
	"./points/56.4.NH3-N.png": "a810",
	"./points/56.5.COD.png": "3769",
	"./points/56.6.CODm.png": "70cd",
	"./points/56.7.Chla.png": "3508",
	"./points/56.8.TSS.png": "5960",
	"./points/56.9.TU.png": "84e1",
	"./points/57.1.jpg": "d38c",
	"./points/57.10.pH.png": "1e67",
	"./points/57.2.TN.png": "8087",
	"./points/57.3.TP.png": "04ac",
	"./points/57.4.NH3-N.png": "c402",
	"./points/57.5.COD.png": "5acb",
	"./points/57.6.CODm.png": "1080",
	"./points/57.7.Chla.png": "061e",
	"./points/57.8.TSS.png": "2131",
	"./points/57.9.TU.png": "4e45",
	"./points/58.1.jpg": "c485",
	"./points/58.10.pH.png": "47a7",
	"./points/58.2.TN.png": "a295",
	"./points/58.3.TP.png": "5a02",
	"./points/58.4.NH3-N.png": "9ae2",
	"./points/58.5.COD.png": "ee90",
	"./points/58.6.CODm.png": "c72a",
	"./points/58.7.Chla.png": "935d",
	"./points/58.8.TSS.png": "a523",
	"./points/58.9.TU.png": "4459",
	"./points/59.1.jpg": "8bd7",
	"./points/59.10.pH.png": "4cb8",
	"./points/59.2.TN.png": "529f",
	"./points/59.3.TP.png": "a9b0",
	"./points/59.4.NH3-N.png": "8895",
	"./points/59.5.COD.png": "5e72",
	"./points/59.6.CODm.png": "a673",
	"./points/59.7.Chla.png": "3932",
	"./points/59.8.TSS.png": "5935",
	"./points/59.9.TU.png": "7db7",
	"./points/6.1.jpg": "ac09",
	"./points/6.10.pH.png": "55e5",
	"./points/6.2.TN.png": "7f97",
	"./points/6.3.TP.png": "2a3f",
	"./points/6.4.NH3-N.png": "2e3f",
	"./points/6.5.COD.png": "c9b0",
	"./points/6.6.CODm.png": "8a8c",
	"./points/6.7.Chla.png": "023b",
	"./points/6.8.TSS.png": "869d",
	"./points/6.9.TU.png": "d849",
	"./points/60.1.jpg": "4bf0",
	"./points/60.10.pH.png": "77ee",
	"./points/60.2.TN.png": "aa3f",
	"./points/60.3.TP.png": "bb32",
	"./points/60.4.NH3-N.png": "984b",
	"./points/60.5.COD.png": "bfab",
	"./points/60.6.CODm.png": "dea8",
	"./points/60.7.Chla.png": "4aef",
	"./points/60.8.TSS.png": "b0ec",
	"./points/60.9.TU.png": "b0a1",
	"./points/61.1.jpg": "70f8",
	"./points/61.10.pH.png": "42a1",
	"./points/61.2.TN.png": "8db7",
	"./points/61.3.TP.png": "f248",
	"./points/61.4.NH3-N.png": "caf7",
	"./points/61.5.COD.png": "7edb",
	"./points/61.6.CODm.png": "9da0",
	"./points/61.7.Chla.png": "d101",
	"./points/61.8.TSS.png": "db48",
	"./points/61.9.TU.png": "1a1c",
	"./points/62.1.jpg": "0216",
	"./points/62.10.pH.png": "0727",
	"./points/62.2.TN.png": "665c",
	"./points/62.3.TP.png": "7ab7",
	"./points/62.4.NH3-N.png": "7beb",
	"./points/62.5.COD.png": "3fb4",
	"./points/62.6.CODm.png": "ba26",
	"./points/62.7.Chla.png": "26a3",
	"./points/62.8.TSS.png": "1178",
	"./points/62.9.TU.png": "a6d7",
	"./points/63.1.jpg": "a3c7",
	"./points/63.10.TU.png": "5386",
	"./points/63.2.TN.png": "1356",
	"./points/63.3.TP.png": "1576",
	"./points/63.4.NH3-N.png": "5ff8",
	"./points/63.5.COD.png": "c865",
	"./points/63.6.CODm.png": "1f8d",
	"./points/63.7.Chla.png": "fefb",
	"./points/63.8.TSS.png": "bcfe",
	"./points/63.9.pH.png": "2a07",
	"./points/64.1.jpg": "61bb",
	"./points/64.10.pH.png": "991b",
	"./points/64.2.TN.png": "3a01",
	"./points/64.3.TP.png": "f06a",
	"./points/64.4.NH3-N.png": "ed60",
	"./points/64.5.COD.png": "ce77",
	"./points/64.6.CODm.png": "d135",
	"./points/64.7.Chla.png": "f347",
	"./points/64.8.TSS.png": "14c6",
	"./points/64.9.TU.png": "0152",
	"./points/65.1.jpg": "627a",
	"./points/65.10.pH.png": "7e7b",
	"./points/65.2.TN.png": "fe9f",
	"./points/65.3.TP.png": "6e0d",
	"./points/65.4.NH3-N.png": "cbe0",
	"./points/65.5.COD.png": "ee2d",
	"./points/65.6.CODm.png": "7ab1",
	"./points/65.7.Chla.png": "2b8d",
	"./points/65.8.TSS.png": "e5a1",
	"./points/65.9.TU.png": "e845",
	"./points/66.1.jpg": "8a8d",
	"./points/66.10.pH.png": "da53",
	"./points/66.2.TN.png": "6156",
	"./points/66.3.TP.png": "609e",
	"./points/66.4.NH3-N.png": "3b72",
	"./points/66.5.COD.png": "1fbd",
	"./points/66.6.CODm.png": "a08d",
	"./points/66.7.Chla.png": "537c",
	"./points/66.8.TSS.png": "419e",
	"./points/66.9.TU.png": "ba47",
	"./points/67.1.jpg": "0e33",
	"./points/67.10.pH.png": "a04e",
	"./points/67.2.TN.png": "6a97",
	"./points/67.3.TP.png": "13c3",
	"./points/67.4.NH3-N.png": "c6a3",
	"./points/67.5.COD.png": "7290",
	"./points/67.6.CODm.png": "b97c",
	"./points/67.7.Chla.png": "f550",
	"./points/67.8.TSS.png": "833c",
	"./points/67.9.TU.png": "8d3e",
	"./points/68.1.jpg": "e441",
	"./points/68.10.pH.png": "5de6",
	"./points/68.2.TN.png": "e32b",
	"./points/68.3.TP.png": "4276",
	"./points/68.4.NH3-N.png": "df68",
	"./points/68.5.COD.png": "3d34",
	"./points/68.6.CODm.png": "7d63",
	"./points/68.7.Chla.png": "bcb2",
	"./points/68.8.TSS.png": "54fa",
	"./points/68.9.TU.png": "a2b5",
	"./points/69.1.jpg": "bfce",
	"./points/69.10.pH.png": "f092",
	"./points/69.2.TN.png": "dd10",
	"./points/69.3.TP.png": "8f17",
	"./points/69.4.NH3-N.png": "47d5",
	"./points/69.5.COD.png": "f709",
	"./points/69.6.CODm.png": "697b",
	"./points/69.7.Chla.png": "c68f",
	"./points/69.8.TSS.png": "afee",
	"./points/69.9.TU.png": "386e",
	"./points/7.1.jpg": "5170",
	"./points/7.10.pH.png": "68f6",
	"./points/7.2.TN.png": "1015",
	"./points/7.3.TP.png": "4ece",
	"./points/7.4.NH3-N.png": "e02c",
	"./points/7.5.COD.png": "8048",
	"./points/7.6.CODm.png": "85f2",
	"./points/7.7.Chla.png": "dd47",
	"./points/7.8.TSS.png": "45a1",
	"./points/7.9.TU.png": "2d4f",
	"./points/70.1.jpg": "eef8",
	"./points/70.10.pH.png": "d9ac",
	"./points/70.2.TN.png": "4e44",
	"./points/70.3.TP.png": "1262",
	"./points/70.4.NH3-N.png": "4746",
	"./points/70.5.COD.png": "a03b",
	"./points/70.6.CODm.png": "6a84",
	"./points/70.7.Chla.png": "a143",
	"./points/70.8.TSS.png": "dd73",
	"./points/70.9.TU.png": "00ff",
	"./points/71.1.jpg": "02bf",
	"./points/71.10.pH.png": "b2f3",
	"./points/71.2.TN.png": "0725",
	"./points/71.3.TP.png": "fd66",
	"./points/71.4.NH3-N.png": "ee5e",
	"./points/71.5.COD.png": "414a",
	"./points/71.6.CODm.png": "a47d",
	"./points/71.7.Chla.png": "4b8c",
	"./points/71.8.TSS.png": "f095",
	"./points/71.9.TU.png": "3bd0",
	"./points/72.1.jpg": "c29f",
	"./points/72.10.pH.png": "70a1",
	"./points/72.2.TN.png": "3e8b",
	"./points/72.3.TP.png": "9ab2",
	"./points/72.4.NH3-N.png": "ff62",
	"./points/72.5.COD.png": "debb",
	"./points/72.6.CODm.png": "f4e7",
	"./points/72.7.Chla.png": "d2b6",
	"./points/72.8.TSS.png": "d452",
	"./points/72.9.TU.png": "c0a2",
	"./points/73.1.jpg": "3d8f",
	"./points/73.10.pH.png": "846d",
	"./points/73.2.TN.png": "4fbf",
	"./points/73.3.TP.png": "c11d",
	"./points/73.4.NH3-N.png": "5f16",
	"./points/73.5.COD.png": "c978",
	"./points/73.6.CODm.png": "0fd8",
	"./points/73.7.Chla.png": "1298",
	"./points/73.8.TSS.png": "4c74",
	"./points/73.9.TU.png": "e1c0",
	"./points/74.1.jpg": "27cc",
	"./points/74.10.pH.png": "82cf",
	"./points/74.2.TN.png": "096d",
	"./points/74.3.TP.png": "2ac9",
	"./points/74.4.NH3-N.png": "281f",
	"./points/74.5.COD.png": "ab19",
	"./points/74.6.CODm.png": "1b90",
	"./points/74.7.Chla.png": "68a0",
	"./points/74.8.TSS.png": "9da8",
	"./points/74.9.TU.png": "96e3",
	"./points/75.1.jpg": "da88",
	"./points/75.10.pH.png": "1420",
	"./points/75.2.TN.png": "7d6b",
	"./points/75.3.TP.png": "19f6",
	"./points/75.4.NH3-N.png": "73e3",
	"./points/75.5.COD.png": "54e4",
	"./points/75.6.CODm.png": "ccc0",
	"./points/75.7.Chla.png": "3e56",
	"./points/75.8.TSS.png": "1c17",
	"./points/75.9.TU.png": "8610",
	"./points/76.1.jpg": "5897",
	"./points/76.10.pH.png": "c93b",
	"./points/76.2.TN.png": "2083",
	"./points/76.3.TP.png": "1944",
	"./points/76.4.NH3-N.png": "437c",
	"./points/76.5.COD.png": "194c",
	"./points/76.6.CODm.png": "00b0",
	"./points/76.7.Chla.png": "aeb2",
	"./points/76.8.TSS.png": "de9e",
	"./points/76.9.TU.png": "e764",
	"./points/77.1.jpg": "2fa0",
	"./points/77.10.pH.png": "0f05",
	"./points/77.2.TN.png": "8f1c",
	"./points/77.3.TP.png": "e2b8",
	"./points/77.4.NH3-N.png": "05f0",
	"./points/77.5.COD.png": "3b67",
	"./points/77.6.CODm.png": "26f9",
	"./points/77.7.Chla.png": "ca8e",
	"./points/77.8.TSS.png": "0da3",
	"./points/77.9.TU.png": "af8b",
	"./points/78.1.jpg": "6fb9",
	"./points/78.10.pH.png": "9fbc",
	"./points/78.2.TN.png": "4888",
	"./points/78.3.TP.png": "a60d",
	"./points/78.4.NH3-N.png": "19fc",
	"./points/78.5.COD.png": "c39f",
	"./points/78.6.CODm.png": "9de5",
	"./points/78.7.Chla.png": "f6cc",
	"./points/78.8.TSS.png": "2acb",
	"./points/78.9.TU.png": "1224",
	"./points/79.1.jpg": "4dd6",
	"./points/79.10.pH.png": "e0de",
	"./points/79.2.TN.png": "7236",
	"./points/79.3.TP.png": "055b",
	"./points/79.4.NH3-N.png": "2f98",
	"./points/79.5.COD.png": "0a8b",
	"./points/79.6.CODm.png": "7beb0",
	"./points/79.7.Chla.png": "6a8b",
	"./points/79.8.TSS.png": "5127",
	"./points/79.9.TU.png": "e0fa",
	"./points/8.1.jpg": "68f69",
	"./points/8.10.pH.png": "80a3",
	"./points/8.2.TN.png": "2870",
	"./points/8.3.TP.png": "634b",
	"./points/8.4.NH3-N.png": "cef2",
	"./points/8.5.COD.png": "1c81",
	"./points/8.6.CODm.png": "89b9",
	"./points/8.7.Chla.png": "3706",
	"./points/8.8.TSS.png": "b6ac",
	"./points/8.9.TU.png": "219b",
	"./points/80.1.jpg": "d455",
	"./points/80.10.pH.png": "b771",
	"./points/80.2.TN.png": "e46b5",
	"./points/80.3.TP.png": "7c08",
	"./points/80.4.NH3-N.png": "8d80",
	"./points/80.5.COD.png": "e954",
	"./points/80.6.CODm.png": "6208",
	"./points/80.7.Chla.png": "33f2",
	"./points/80.8.TSS.png": "cff0",
	"./points/80.9.TU.png": "498c",
	"./points/81.1.jpg": "9ec0",
	"./points/81.10.pH.png": "1cf0",
	"./points/81.2.TN.png": "b4ba",
	"./points/81.3.TP.png": "b6dd",
	"./points/81.4.NH3-N.png": "10a6",
	"./points/81.5.COD.png": "1eff",
	"./points/81.6.CODm.png": "9d3c",
	"./points/81.7.Chla.png": "5c63",
	"./points/81.8.TSS.png": "be0b",
	"./points/81.9.TU.png": "1af5",
	"./points/82.1.jpg": "06c0",
	"./points/82.10.pH.png": "ee42",
	"./points/82.2TN.png": "ac88",
	"./points/82.3.TP.png": "56c1",
	"./points/82.4.NH3-N.png": "d237",
	"./points/82.5.COD.png": "6a5a",
	"./points/82.6.CODm.png": "696b",
	"./points/82.7.Chla.png": "5706",
	"./points/82.8.TSS.png": "1083",
	"./points/82.9.TU.png": "16ed",
	"./points/83.1.jpg": "e34c",
	"./points/83.10.pH.png": "2a74",
	"./points/83.2.TN.png": "6b89",
	"./points/83.3.TP.png": "6acc",
	"./points/83.4.NH3-N.png": "7ea7",
	"./points/83.5.COD.png": "3d99",
	"./points/83.6.CODm.png": "659d",
	"./points/83.7.Chla.png": "8247",
	"./points/83.8.TSS.png": "9b09",
	"./points/83.9.TU.png": "e847",
	"./points/84.1.jpg": "1ca3",
	"./points/84.10.pH.png": "bbb9",
	"./points/84.2.TN.png": "328d",
	"./points/84.3.TP.png": "d6be",
	"./points/84.4.NH3-N.png": "34f9",
	"./points/84.5.COD.png": "ae72",
	"./points/84.6.CODm.png": "94df",
	"./points/84.7.Chla.png": "8a8c9",
	"./points/84.8.TSS.png": "4e02",
	"./points/84.9.TU.png": "4b7a",
	"./points/85.1.jpg": "ab27",
	"./points/85.10.pH.png": "02f2",
	"./points/85.2.TN.png": "dcf0",
	"./points/85.3.TP.png": "f96e",
	"./points/85.4.NH3-N.png": "22d7",
	"./points/85.5.COD.png": "af28",
	"./points/85.6.CODm.png": "99a7",
	"./points/85.7.Chla.png": "8542",
	"./points/85.8.TSS.png": "1553",
	"./points/85.9.TU.png": "09ad",
	"./points/86.1.jpg": "99f0",
	"./points/86.10.pH.png": "624f",
	"./points/86.2.TN.png": "b593",
	"./points/86.3.TP.png": "3990",
	"./points/86.4.NH3-N.png": "b39f",
	"./points/86.5.COD.png": "5a7d",
	"./points/86.6.CODm.png": "45f6",
	"./points/86.7.Chla.png": "8a420",
	"./points/86.8.TSS.png": "3337",
	"./points/86.9.TU.png": "ee83",
	"./points/87.1.jpg": "c9f8",
	"./points/87.10.pH.png": "578c",
	"./points/87.2.TN.png": "a4e5",
	"./points/87.3.TP.png": "744e",
	"./points/87.4.NH3-N.png": "abfe",
	"./points/87.5.COD.png": "8afe",
	"./points/87.6.CODm.png": "70bd",
	"./points/87.7.Chla.png": "6e3d",
	"./points/87.8.TSS.png": "bb3f",
	"./points/87.9.TU.png": "8ed4",
	"./points/88.1.jpg": "0de4",
	"./points/88.10.pH.png": "b80b",
	"./points/88.2.TN.png": "a725",
	"./points/88.3.TP.png": "8728c",
	"./points/88.4.NH3-N.png": "7524",
	"./points/88.5.COD.png": "4dd0",
	"./points/88.6.CODm.png": "c0bf",
	"./points/88.7.Chla.png": "a1d4",
	"./points/88.8.TSS.png": "b08f",
	"./points/88.9.TU.png": "8139",
	"./points/89.1.jpg": "150b",
	"./points/89.10.pH.png": "7659",
	"./points/89.2.TN.png": "9a02",
	"./points/89.3.TP.png": "2375",
	"./points/89.4.NH3-N.png": "6145",
	"./points/89.5.COD.png": "38a1",
	"./points/89.6.CODm.png": "21cb",
	"./points/89.7.Chla.png": "f21b",
	"./points/89.8.TSS.png": "207b",
	"./points/89.9.TU.png": "36f1",
	"./points/9.1.jpg": "8914",
	"./points/9.10.pH.png": "dd3a",
	"./points/9.2.TN.png": "9e36",
	"./points/9.3.TP.png": "ef2a0",
	"./points/9.4.NH3-N.png": "3a81",
	"./points/9.5.COD.png": "05d9",
	"./points/9.6.CODm.png": "0361",
	"./points/9.7.Chla.png": "30c2",
	"./points/9.8.TSS.png": "302e",
	"./points/9.9.TU.png": "af5e",
	"./points/90.1.jpg": "f911",
	"./points/90.10.pH.png": "fe3f",
	"./points/90.2.TN.png": "545f",
	"./points/90.3.TP.png": "e4aa",
	"./points/90.4.NH3-N.png": "08a8",
	"./points/90.5.COD.png": "da05",
	"./points/90.6.CODm.png": "b222",
	"./points/90.7.Chla.png": "2508",
	"./points/90.8.TSS.png": "7d73",
	"./points/90.9.TU.png": "2702",
	"./points/91.1.jpg": "174e",
	"./points/91.10.pH.png": "a593",
	"./points/91.2.TN.png": "4277",
	"./points/91.3.TP.png": "5fa9",
	"./points/91.4.NH3-N.png": "ae9e",
	"./points/91.5.COD.png": "eb0d",
	"./points/91.6.CODm.png": "185d",
	"./points/91.7.Chla.png": "1cdb",
	"./points/91.8.TSS.png": "b9d7",
	"./points/91.9.TU.png": "a3c3",
	"./points/92.1.jpg": "433e",
	"./points/92.10.pH.png": "1b97",
	"./points/92.2.TN.png": "3cbf",
	"./points/92.3.TP.png": "9fc7",
	"./points/92.4.NH3-N.png": "1da13",
	"./points/92.5.COD.png": "959d",
	"./points/92.6.CODm.png": "4eee",
	"./points/92.7.Chla.png": "fb79",
	"./points/92.8.TSS.png": "c31c",
	"./points/92.9.TU.png": "e890",
	"./points/93.1.jpg": "d081",
	"./points/93.10.pH.png": "5138",
	"./points/93.2.TN.png": "9d9b",
	"./points/93.3.TP.png": "c7b2",
	"./points/93.4.NH3-N.png": "56d1",
	"./points/93.5.COD.png": "8cc1",
	"./points/93.6.CODm.png": "d148",
	"./points/93.7.Chla.png": "699a",
	"./points/93.8.TSS.png": "af02",
	"./points/93.9.TU.png": "a3e2",
	"./points/94.1.jpg": "9d70",
	"./points/94.10.pH.png": "61c5",
	"./points/94.2.TN.png": "d56e",
	"./points/94.3.TP.png": "e943",
	"./points/94.4.NH3-N.png": "a55b3",
	"./points/94.5.COD.png": "144b",
	"./points/94.6.CODm.png": "d82c",
	"./points/94.7.Chla.png": "9741",
	"./points/94.8.TSS.png": "0c37",
	"./points/94.9.TU.png": "137e",
	"./points/95.1.jpg": "476c",
	"./points/95.10.pH.png": "45be",
	"./points/95.2.TN.png": "a49c",
	"./points/95.3.TP.png": "162a",
	"./points/95.4.NH3-N.png": "13a9",
	"./points/95.5.COD.png": "9a30",
	"./points/95.6.CODm.png": "b5b1",
	"./points/95.7.Chla.png": "fdeb",
	"./points/95.8.TSS.png": "3827",
	"./points/95.9.TU.png": "6d6d",
	"./points/96.1.jpg": "be1b",
	"./points/96.10.pH.png": "3f5a",
	"./points/96.2.TN.png": "bdbf",
	"./points/96.3.TP.png": "9fc2",
	"./points/96.4.NH3-N.png": "5776",
	"./points/96.5.COD.png": "7ae4",
	"./points/96.6.CODm.png": "7f07",
	"./points/96.7.Chla.png": "32c9",
	"./points/96.8.TSS.png": "39eb",
	"./points/96.9.TU.png": "4e43",
	"./points/97.1.jpg": "7c9d",
	"./points/97.10.png": "45dd",
	"./points/97.2.png": "2ce4",
	"./points/97.3.png": "c87c",
	"./points/97.4.png": "ffb5",
	"./points/97.5.png": "9726",
	"./points/97.6.png": "f392",
	"./points/97.7.png": "eeb0",
	"./points/97.8.png": "b110",
	"./points/97.9.png": "6d6c",
	"./points/98.1.jpg": "01b2",
	"./points/98.10.png": "b2a0",
	"./points/98.2.png": "45e4",
	"./points/98.3.png": "2ac98",
	"./points/98.4.png": "5250",
	"./points/98.5.png": "8b91",
	"./points/98.6.png": "9407",
	"./points/98.7.png": "6db0",
	"./points/98.8.png": "96a6",
	"./points/98.9.png": "d616",
	"./points/99.1.jpg": "117b",
	"./points/99.10.png": "9414",
	"./points/99.2.png": "aa38",
	"./points/99.3.png": "3ba5",
	"./points/99.4.png": "4a5d",
	"./points/99.5.png": "f00d",
	"./points/99.6.png": "a402",
	"./points/99.7.png": "600c",
	"./points/99.8.png": "a9de",
	"./points/99.9.png": "f0a8",
	"./task/1.1.png": "5cec",
	"./task/1.2.png": "bfca",
	"./task/1.3.png": "7389",
	"./task/1.4.png": "4c34",
	"./task/1.5.png": "03d0",
	"./task/1.6.png": "2e48",
	"./task/1.7.png": "bbd7",
	"./task/1.8.png": "be53",
	"./task/1.9.png": "a40b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8af1";